export const getShipment = async shipmentId => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/core-service/shipments/tracking/${shipmentId}`,
    );
    const data = await res.json();

    if (data?.error) {
      throw new Error(
        data?.error?.message ||
          "Something went wrong. Please contact Autosled Support.",
      );
    }

    return data;
  } catch (err) {
    console.error("Error fetching data", err);
    throw err;
  }
};

export const getAppConfig = async controller => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/abp/application-configuration`,
      {
        method: "GET",
        signal: controller?.signal,
        params: {
          IncludeLocalizationResources: true,
        },
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    const data = await res.json();

    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};
